<template>
  <!-- 量表介绍 -->
  <div class="scale-introduce">
    <div class="title"><span>量表介绍</span></div>
    <div class="content">
      <div class="scale-item" v-for="item in scaleIntroduceList" :key="item.ID">
        <div class="scale-name">
          <!-- <i :class="item.Icon"></i> -->
          {{ item.Title }}
        </div>
        <div class="scale-describe">
          {{ item.Introduce }}
          <span @click="detailScaleIntroduce(item.ID)">【查看详情】</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from "@/common/request";
export default {
  data() {
    return {
      scaleIntroduceList: [],
    };
  },
  created() {
    this.getScaleIntroduceList(); // 获取量表介绍列表
  },
  methods: {
    // 获取量表介绍列表
    getScaleIntroduceList() {
      Axios("Sys/ScaleIntroduceList", "get", {}, this)
        .then((ret) => {
          if (ret.Status && ret.Data) {
            this.scaleIntroduceList = ret.Data;
          }
        })
        .catch((err) => {
          this.$message.err("获取量表介绍错误");
        });
    },
    // 查看详情
    detailScaleIntroduce(id) {
      this.$router.push({
        path: "/introduceDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.scale-introduce {
  // padding-top: 20px;
  min-height: 300px;
  background: #fff;
  font-family: "Raleway", Arial, sans-serif;
  border-radius: 10px;
  .title {
    margin: 20px 0;
    padding-left: 25px;
    color: #000;
    font-size: 24px;
    font-weight: 500;
    span {
      padding-bottom: 10px;
      border-bottom: 2px solid rgb(195, 195, 195);
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    .scale-item {
      width: 33.33%;
      padding: 20px 30px;
      box-sizing: border-box;
      .scale-name {
        margin-bottom: 5px;
        font-size: 18px;
        font-weight: 500;
        color: #000;
        text-align: left;

        i {
          font-size: 32px;
          color: #aaa;
        }
      }
      .scale-describe {
        text-align: left;
        color: #898989;
        font-size: 15px;
        line-height: 30px;
        span {
          cursor: pointer;
          color: #409eff;
        }
        span:hover {
          color: #01058a;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scaleIntroduce.vue